import QInput from 'quasar/src/components/input/QInput.js';
import { defineComponent, ref } from "vue";
export default defineComponent({
    name: "PrimeNumberInput",
    extends: {
        QInput
    },
    props: {
        updateValue: {
            type: Function,
            required: true
        },
        /** 更新値をnumber型で受け取るか否か
         * デフォルトではfalse (stringで受け取る)
         */
        isReturnNumber: {
            type: Boolean,
            default: false
        },
        /** 浮動小数点としてカンマを含めて入力可能か否か
         * デフォルトではfalse (整数扱い、カンマ入力不可)
         */
        isFloat: {
            type: Boolean,
            default: false
        },
        /** マイナス値を入力可能か否か
         * デフォルトではfalse (マイナス値入力不可)
         */
        isEnabledMinus: {
            type: Boolean,
            default: false
        }
    },
    setup: (props) => {
        QInput.setup;
        const inputElement = ref(null);
        const onUpdateValue = (value) => {
            if (!value) {
                props.updateValue(null);
                return;
            }
            let str = props.isEnabledMinus ? value.replace(/[^0-9.-]/g, "") : value.replace(/[^0-9.]/g, "");
            if (!props.isFloat) {
                str = str.replace(".", "");
            }
            if (!str) {
                props.updateValue(null);
                return;
            }
            if (props.isReturnNumber) {
                str = formatInvalidPeriod(str);
                const strNum = props.isFloat ? Number.parseFloat(str) : Number.parseInt(str, 10);
                props.updateValue(strNum);
                return;
            }
            props.updateValue(str);
        };
        const onFormatValue = () => {
            if (!props.isFloat) {
                return;
            }
            let str = inputElement.value.$el.querySelector("input").value;
            str = spliceDuplicatePeriod(str);
            str = formatInvalidPeriod(str);
            if (props.isReturnNumber) {
                const strNum = props.isFloat ? Number.parseFloat(str) : Number.parseInt(str, 10);
                props.updateValue(strNum);
                return;
            }
            props.updateValue(str);
        };
        const spliceDuplicatePeriod = (str) => {
            const firstIndex = str.indexOf(".");
            if (firstIndex === -1) {
                return str;
            }
            let targetIndex = NaN;
            let result = str;
            while (targetIndex !== -1) {
                targetIndex = result.indexOf(".", firstIndex + 1);
                if (targetIndex !== -1) {
                    result = result.slice(0, targetIndex) + result.slice(targetIndex + 1);
                }
            }
            return result;
        };
        const formatInvalidPeriod = (str) => {
            if (!/\d\./.test(str)) {
                str = str.replace(".", "0.");
            }
            if (!/\.\d/.test(str)) {
                str = str.replace(".", ".0");
            }
            return str;
        };
        return {
            props,
            inputElement,
            onUpdateValue,
            onFormatValue
        };
    }
});
